import React from 'react';
import {
  Checkbox,
  checkboxClasses,
  FormControl,
  FormControlLabel,
  styled,
  svgIconClasses,
  Typography,
} from '@mui/material';
import { IconCheckmark } from 'assets/img';
import { StyledFormHelperText } from 'public/components/common/forms/form-helper-text/form-helper-text';
import { TermsAndConditionsProps } from './types';
import { config } from '../../../styles/config';

export const TermsAndConditions = ({
  name,
  isChecked,
  onCheckChange,
  children,
  error,
}: React.PropsWithChildren<TermsAndConditionsProps>) => {
  return (
    <FormControl variant="filled" fullWidth>
      <FormControlLabel
        id={`${name}-label`}
        control={
          <StyledCheckbox
            name={name}
            checkedIcon={<IconCheckmark className={svgIconClasses.root} />}
            checked={isChecked}
            onChange={onCheckChange}
          />
        }
        label={<StyledText>{children}</StyledText>}
      />

      {error ? <StyledFormHelperText>{error}</StyledFormHelperText> : null}
    </FormControl>
  );
};

const StyledText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  fontWeight: 400,
  color: theme.palette.lwBlack[100],
  marginLeft: theme.spacing(2),
  lineHeight: 1.5,
}));

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  [`&.${checkboxClasses.root}`]: {
    padding: theme.spacing(1),
    borderWidth: theme.spacing(0.25),

    [`& svg[class^=${svgIconClasses.root}]`]: {
      borderRadius: theme.spacing(2),
    },

    '&:hover': {
      borderRadius: theme.spacing(2),
    },

    '&:active': {
      borderColor: config.colors.active,
    },

    [`&.${checkboxClasses.disabled}`]: {
      [`& svg[class^=${svgIconClasses.root}]`]: {
        backgroundColor: config.colors.disabled[50],
        borderColor: config.colors.disabled[50],
      },
    },

    [`&.${checkboxClasses.checked}`]: {
      [`& svg[class^=${svgIconClasses.root}]`]: {
        backgroundColor: config.colors.primary,
        borderColor: config.colors.primary,
        '& path': {
          stroke: theme.palette.lwBlack[100],
          fill: 'none',
        },
      },
    },

    [`& svg[class^=${svgIconClasses.root}]`]: {
      fill: theme.palette.lwWhite[100],
      backgroundColor: theme.palette.lwWhite[100],
      borderWidth: theme.spacing(0.25),
      borderStyle: 'solid',
      borderColor: theme.palette.lwBlack[20],
      borderRadius: theme.spacing(1.5),
    },
  },
}));
